import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MobileLegalHubPage.css';

const ChevronRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const rows = [
  { label: 'Terms of License and Use', to: '/mobile/legal/terms-of-license' },
  { label: 'Privacy Policy', to: '/mobile/legal/privacy' },
  { label: 'Cookie Preferences', to: '/mobile/legal/cookies' },
  { label: 'Authorization management', to: '/mobile/legal/authorization' }
];

export default function MobileLegalHubPage() {
  const navigate = useNavigate();

  return (
    <div className="mlegalhub-page">
      <div className="mlegalhub-header">
        <button type="button" className="mlegalhub-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mlegalhub-title">Legal policies</h1>
      </div>
      <div className="mlegalhub-list">
        {rows.map((r, i) => (
          <button
            key={r.to}
            type="button"
            className={i < rows.length - 1 ? 'mlegalhub-row mlegalhub-row--line' : 'mlegalhub-row'}
            onClick={() => navigate(r.to)}
          >
            <span className="mlegalhub-lab">{r.label}</span>
            <ChevronRight />
          </button>
        ))}
      </div>
    </div>
  );
}
